let isActive = false;

export function getIsActive() {
    return isActive;
}

export function setIsActive(value) {
    isActive = value;
}

export function initNav() {
    $('#canvas').on('mousedown', () => {
        $('#canvas').css('cursor', 'grabbing');
    })


    $('#canvas').on('mouseup', () => {
        $('#canvas').css('cursor', 'grab');
    })

    $('#hamburger').on('click', () => {
        hamburger();
    });

    const hamburger = () => {
        $('.threeSideNav').toggleClass('threeSideNav-active');

        if(getIsActive()) {
            $('#threeSideNav-inner').animate({opacity: 0}, 150);
        }
        
        setTimeout(() => {
            if(!getIsActive()) {
                $('#threeSideNav-inner').animate({opacity: 1}, 150);
            }
            setIsActive(!getIsActive());
        }, 300)
    }

    //open
    $('#rightAside-open').on('click', async () => {
        r_open();
    })

    //close
    $('#rightAside-close').on('click', () => {
        r_close();
    })

    //expand
    $('.rightAside .card').on('click', () => {
        r_expand();
    })

    //back
    $('#rightAside-back').on('click', () => {
        r_back();
    })

}

export const r_open = () => {
    $('.rightAside').addClass('rightAside-active');
    setTimeout(() => {
        $('.rightAside-inner').fadeIn(150);
    }, 300)
}

export const r_close = () => {
    $('.rightAside').removeClass('rightAside-active');
    $('.rightAside').removeClass('rightAside-wide');
    $('.rightAside-wide-inner').fadeOut(150);
    $('.rightAside-inner').fadeOut(150);
    $('#rightAside-back').fadeOut(150);

    setTimeout(() => {
      clearExpanded();
    }, 150);
}

export const r_expand = () => {
    $('.rightAside').addClass('rightAside-active');
    $('.rightAside').addClass('rightAside-wide');
    $('.rightAside-inner').fadeOut(150);
    setTimeout(() => {
        $('.rightAside-wide-inner').fadeIn(150);
        $('#rightAside-back').css('display', 'flex');
    }, 300);
}

export const r_back = () => {
    $('.rightAside').removeClass('rightAside-wide');
    $('.rightAside-wide-inner').fadeOut(150);
    $('#rightAside-back').css('display', 'none');
    setTimeout(() => {
        clearExpanded();
    }, 150);
    setTimeout(() => {
        $('.rightAside-inner').fadeIn(150);
    }, 300);
}

const clearExpanded = () => {
    $('.rightAside-wide-inner-inner').remove();
}
